export const normalizeRedirectHtml = (html = "") => {
  if (typeof window === "undefined") {
    return ""
  }

  const parser = new window.DOMParser()
  const document = parser.parseFromString(html, "text/html")
  const decodedTextContent = (document.body.textContent || "")
    .replace(/\u00A0/g, " ")
    .trim()

  if (
    decodedTextContent.includes("<section") ||
    decodedTextContent.includes("<div") ||
    decodedTextContent.includes("<img") ||
    decodedTextContent.includes("<style")
  ) {
    const apiBaseUrl = process.env.REACT_APP_API || ""

    return apiBaseUrl
      ? decodedTextContent.replace(/https?:\/\/localhost:8001/gi, apiBaseUrl)
      : decodedTextContent
  }

  return html
}
